import styled from 'styled-components';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

type FormatOptionLabelContainerProps = {
    isDisabled: boolean,
}

export const FormatOptionLabelContainer = styled.div<FormatOptionLabelContainerProps>`
    display: flex;
    justify-content: space-between;
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
`;

export const Icon = styled(FontAwesomeIcon)<FontAwesomeIconProps>`
    font-size: 12px;
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.banana300};
`;
